module.exports = __webpack_public_path__ + "static/img/Baby Products.7f3f4a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applications/Baby Products.jpg
// module id = TgYS
// module chunks = 1